<template>
  <Transition
    name="zoom-up-transition"
    :duration="duration"
    enter-active-class="zoom-move"
    enter-from-class="zoomInUp"
    leave-to-class="zoomOutUp"
    leave-active-class="zoom-move"
  >
    <slot></slot>
  </Transition>
</template>

<script>
import { baseTransition } from "../mixin.js"

export default {
  name: "zoom-up-transition",
  props: {
    styles: {
      type: Object,
      default: () => {
        return {
          animationFillMode: "both",
          animationTimingFunction: "ease-out",
        }
      },
    },
  },
  mixins: [baseTransition],
}
</script>

<style lang="scss">
.zoomInUp,
.zoomOutUp {
  opacity: 0;
  transform: scaleY(0);
  transform-origin: top center;
}

.zoom-move {
  transition: transform 0.3s ease-out;
}
</style>
